import React from 'react'
import { useTranslation } from 'react-i18next'
import { AlertBox, Password, PhoneInput, RadioGroup, SelectInput, TextInput } from '@life-line-lab/components-react';
import { isNil } from 'lodash';
// ANTD
import { Avatar, Col, Row } from 'antd';
import { InfoCircleOutlined, UserOutlined } from '@ant-design/icons';

const DriverInfo = ({
    input,
    error,
    handleAvatarClick,
    handleFieldChange,
    handleRadioChange,
    handleSelectChange,
    handlePhoneChange,
    countryOption,
    stateOption,
}) => {

    const { t } = useTranslation();

    return (
        <React.Fragment>
            {
                input._id ? null :
                    <div className="center header-title">
                        {t("title.driverInformation").toUpperCase()}
                    </div>
            }
            {/* ! Not needed */}
            <div className="center">
                <div className="pointer" onClick={() => { handleAvatarClick() }}>
                    <Avatar
                        size={100}
                        src={input.avatar?.base64String || input.avatar?.file_url}
                        icon={<UserOutlined style={{ fontSize: 100 }} />}
                    />
                </div>
            </div>
            <Row gutter={[15, 15]} className="mt-50">
                <Col xs={24} sm={24} md={12}>
                    <TextInput
                        isRequired={true}
                        label={t("label.fullName")}
                        placeholder={t("txt.firstNameExample")}
                        value={input.fullName}
                        name="fullName"
                        onChange={handleFieldChange}
                    />
                    <AlertBox text={error.fullName} />
                </Col>
                <Col xs={24} sm={24} md={12}>
                    <div className="required-div">
                        <RadioGroup
                            options={[
                                { key: "nationalID", label: t("label.nationalID"), value: "NRIC" },
                                { key: "passport", label: t("label.passport"), value: "PASSPORT" },
                            ]}
                            direction="horizontal"
                            isRequired={true}
                            name="identityType"
                            value={input.identityType}
                            onChange={handleRadioChange}
                        />
                    </div>
                    <TextInput
                        placeholder={t("txt.IDExample")}
                        value={input.passportID}
                        name="passportID"
                        onChange={handleFieldChange}
                    />
                    <AlertBox text={error.passportID} />
                </Col>
                <Col xs={24} sm={24} md={12}>
                    <PhoneInput
                        isRequired={true}
                        isError={!!error.mobileNo}
                        label={t('label.mobileNo')}
                        name="mobileNo"
                        value={input.mobileNo}
                        onChange={(value) => handlePhoneChange(value, 'mobileNo')}
                    />
                    <AlertBox text={error.mobileNo || error["mobileNo.number"]} />
                    {/* {error.mobileNo?.number && <AlertBox text='Number is required' />} */}
                </Col>
                <Col xs={24} sm={24} md={12}>
                    <TextInput
                        isRequired={true}
                        label={t("label.emailAddress").toUpperCase()}
                        placeholder={t("txt.emailAddressExample")}
                        value={input.emailAddress}
                        name="emailAddress"
                        onChange={handleFieldChange}
                    />
                    <AlertBox text={error.emailAddress} />
                </Col>
                <Col xs={24} sm={24} md={12}>
                    <label className='inp-label inp-label--required'>
                        {t('label.homeAddress')}
                    </label>
                    <div className="mb-15">
                        <TextInput
                            isRequired={true}
                            placeholder={t("txt.street1Example")}
                            value={input.street1}
                            name="street1"
                            onChange={handleFieldChange}
                        />
                        <AlertBox text={error.street1} />
                    </div>
                    <div className="mb-15">
                        <TextInput
                            isRequired={true}
                            placeholder={t("txt.street2Example")}
                            value={input.street2}
                            name="street2"
                            onChange={handleFieldChange}
                        />
                        <AlertBox text={error.street2} />
                    </div>
                    <Row gutter={[15, 15]}>
                        <Col xs={24} sm={24} md={12} className="mb-0">
                            <TextInput
                                isRequired={true}
                                placeholder={t("txt.postcode")}
                                value={input.postcode}
                                name="postcode"
                                onChange={handleFieldChange}
                            />
                            <AlertBox text={error.postcode} />
                        </Col>
                        <Col xs={24} sm={24} md={12} className="mb-0">
                            <TextInput
                                isRequired={true}
                                placeholder={t("txt.city")}
                                value={input.city}
                                name="city"
                                onChange={handleFieldChange}
                            />
                            <AlertBox text={error.city} />
                        </Col>
                        <Col xs={24} sm={24} md={12} className="mb-0">
                            <SelectInput
                                showSearch
                                options={stateOption}
                                filterOption={(inputValue, option) =>
                                    option.label.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
                                }
                                value={input.state}
                                isReadonly={isNil(input.country)}
                                name="state"
                                placeholder={t('option.state')}
                                onChange={
                                    (value: string | string[]) =>
                                        handleSelectChange(value, 'state')
                                }
                            />
                            <AlertBox text={error.state} />
                        </Col>
                        <Col xs={24} sm={24} md={12} className="mb-0">
                            <SelectInput
                                showSearch
                                options={countryOption}
                                filterOption={(inputValue, option) =>
                                    option.label.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
                                }
                                value={input.country}
                                name="country"
                                placeholder={t('option.country')}
                                onChange={
                                    (value: string | string[]) =>
                                        handleSelectChange(value, 'country')
                                }
                            />
                            <AlertBox text={error.country} />
                        </Col>
                    </Row>
                </Col>
                <Col xs={24} sm={24} md={12}>
                    <Col xs={24} sm={24} className="mb-7">
                        <SelectInput
                            showSearch
                            options={[
                                {
                                    label: 'Male',
                                    value: 'MALE',
                                },
                                {
                                    label: 'Female',
                                    value: 'FEMALE',
                                },
                            ]}
                            filterOption={(inputValue, option) =>
                                option.label.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
                            }
                            value={input.gender}
                            name="gender"
                            placeholder={t('txt.gender')}
                            onChange={
                                (value: string | string[]) =>
                                    handleSelectChange(value, 'gender')
                            }
                            label={t('label.gender')}
                            isRequired={true}
                        />
                        <AlertBox text={error.gender} />
                    </Col>
                    {/* {
                        input._id ? null :
                            <React.Fragment>
                                <Col xs={24} sm={24} className="mb-7">
                                    <Password
                                        isRequired={true}
                                        label={t("label.password")}
                                        value={input.password}
                                        name="password"
                                        onChange={handleFieldChange}
                                    />
                                    <AlertBox text={error.password && error.password + ' that contains alphanumeric and symbols characters' } />
                                </Col>
                                <Col xs={24} sm={24} className="mb-7">
                                    <Password
                                        isRequired={true}
                                        label={t("label.confirmPwd")}
                                        value={input.confirmPwd}
                                        name="confirmPwd"
                                        onChange={handleFieldChange}
                                    />
                                    <AlertBox text={error.confirmPwd} />
                                </Col>
                            </React.Fragment>
                    } */}
                </Col>
            </Row>
        </React.Fragment>
    )
}

export default DriverInfo
